// services/auth.js - VERSION CORRIGÉE
import axios from 'axios';

// const API_URL = 'http://localhost:8000/api';

const API_URL = 'https://sandbox.sgpme.biz/api';

// Fonction de login qui accepte un dispatch optionnel
export const login = async (credentials, dispatch = null) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login/`, credentials);
    
    if (response.data.access && response.data.refresh) {
      // Stocker dans localStorage
      localStorage.setItem('access_token', response.data.access);
      localStorage.setItem('refresh_token', response.data.refresh);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      
      // Ne plus dispatcher ici - sera fait dans le composant Login
      // Le dispatch sera passé en paramètre depuis le composant
      
      return response.data;
    }
    throw new Error('Invalid response from server');
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Fonction de logout qui accepte un dispatch optionnel
export const logout = (dispatch = null) => {
  // Nettoyer localStorage
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  
  // Ne plus dispatcher ici - sera fait dans le composant Navbar
};

// services/auth.js
export const getCurrentUser = () => {
  try {
    // Essayer d'abord le user stocké par l'API
    const apiUser = localStorage.getItem('user');
    if (apiUser) {
      return JSON.parse(apiUser);
    }
    
    // Sinon, essayer le user stocké par Redux
    const reduxUser = localStorage.getItem('redux_user'); // si vous le stockez différemment
    if (reduxUser) {
      return JSON.parse(reduxUser);
    }
    
    return null;
  } catch (error) {
    console.error("Erreur getCurrentUser:", error);
    return null;
  }
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('access_token');
};

export const getToken = () => {
  return localStorage.getItem('access_token');
};

export const refreshToken = async () => {
  try {
    const refresh = localStorage.getItem('refresh_token');
    if (!refresh) throw new Error('No refresh token');
    
    const response = await axios.post(`${API_URL}/auth/token/refresh/`, {
      refresh: refresh
    });
    
    const newToken = response.data.access;
    localStorage.setItem('access_token', newToken);
    
    return newToken;
  } catch (error) {
    // Appeler logout sans dispatch (sera géré par l'intercepteur)
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    throw error;
  }
};

// Configuration axios globale avec intercepteur
const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        const newToken = await refreshToken();
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        // Redirection vers login sans appeler logout (pour éviter import circulaire)
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;